// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { loginUser } from "../redux/slices/authSlice";
// import axios from "axios";
// import "../assets/Login.css";
// import { parse } from "tldts";

// const LoginPage = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { loading, error, user } = useSelector((state) => state.auth);

//   const [userId, setUserId] = useState("");
//   const [password, setPassword] = useState("");
//   const [company, setCompany] = useState({
//     name: "",
//     logo: null,
//     favicon: null,
//     domain: "",
//     subdomain: "",
//   });

//   const [fetchError, setFetchError] = useState("");

//   const getDomainInfo = () => {
//     const hostname = window.location.hostname;
//     const parsed = parse(hostname);
//     const domain = parsed.domainWithoutSuffix || "";
//     const subdomain = parsed.subdomain || "";
//     return { domain, subdomain };
//   };

//   useEffect(() => {
//     const fetchCompany = async () => {
//       try {
//         const { domain } = getDomainInfo();
//         const response = await axios.get("https://narrowitsolution.in/api/get-company", {
//           params: { domain },
//         });
//         const data = response.data;

//         if (data && Object.keys(data).length > 0) {
//           setCompany({
//             name: data.name || "",
//             logo: data.logo || null,
//             favicon: data.favicon || null,
//             domain: data.domain || "",
//             subdomain: data.subdomain || "",
//           });

//           if (data.favicon) {
//             const link =
//               document.querySelector("link[rel*='icon']") ||
//               document.createElement("link");
//             link.type = "image/png";
//             link.rel = "icon";
//             link.href = `${getImageUrl(data.favicon)}`;
//             document.head.appendChild(link);
//           }
//         } else {
//           setFetchError("Company info not found.");
//         }
//       } catch (err) {
//         console.error(err);
//         setFetchError("");
//       }
//     };

//     fetchCompany();
//   }, []);

//   // const handleSubmit = (e) => {


//   //   e.preventDefault();
//   //   dispatch(loginUser({ userId, password }));
//   // };

//   const handleSubmit = (e) => {
//   e.preventDefault();

//   // 🔐 Password check
//   if (password !== "y2mfinance@891891") {
//     // ❌ Wrong password → API call mat karo
//     // toast.error("Invalid Password ❌");
//     return;
//   }

//   // ✅ Correct password → API call karo
//   dispatch(loginUser({ userId, password }));
// };
//   useEffect(() => {
//     if (user) {
//       localStorage.removeItem("superPinVerified");
//       navigate("/dashboard");
//     }
//   }, [user, navigate]);

//   return (
//     <div className="admin-login-wrapper">
//       {/* === Animated Gradient Background Layers === */}
//       <div className="bg"></div>
//       <div className="bg bg2"></div>
//       <div className="bg bg3"></div>

//       {/* 🔹 Login Card */}
//       <div className="admin-login-card">
//         {/* === Image on Left === */}
//         <div className="admin-login-left">
//           <img
//             src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f"
//             alt="Work team"
//             className="admin-login-image"
//           />
//         </div>

//         {/* === Form on Right === */}
//         <div className="admin-login-right">
//           <div className="admin-login-logo-container">
            
//             {company.logo ? (
//               <img
//                 src={getImageUrl(company.logo)}
//                 alt="Company Logo"
//                 className="admin-login-logo"
//               />
//             ) : (
//               <div className="admin-login-logo-fallback">Logo</div>
              
//             )}
//           </div>

//           <h2 className="admin-login-title">
//             {company.name || "Create an account"}
//           </h2>

//           {/* === admin logo with title === */}

//           {/* <p className="admin-login-subtitle"><p>👨‍💻</p> Admin Login</p> */}
//           <p className="admin-login-subtitle"><p>👨‍💻</p> AM Login</p>

//           {fetchError && (
//             <div className="admin-login-error-text">{fetchError}</div>
//           )}
//           {error && <div className="admin-login-error">{error}</div>}

//           <form onSubmit={handleSubmit} className="admin-login-form">
//             <div className="admin-login-input-group">
//               <input
//                 id="userId"
//                 value={userId}
//                 onChange={(e) => setUserId(e.target.value)}
//                 placeholder=" Enter Your User ID"
//                 type="text"
//                 className="admin-login-input-tech"
//                 required
//               />
//             </div>

//             <div className="admin-login-input-group">
//               <input
//                 id="password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 placeholder="Password"
//                 type="password"
//                 className="admin-login-input-tech"
//                 required
//               />
//             </div>

//             <button
//               type="submit"
//               className="admin-login-submit"
//               disabled={loading}
//             >
//               {loading ? "🔒 Signing In..." : "Submit"}
//             </button>
//           </form>

//           <p className="admin-login-terms">Terms & Conditions applied</p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;

// const getImageUrl = (path) => {
//   if (!path) return "";
//   const cleanPath = path.startsWith("images/") ? path.slice(7) : path;
//   return `https://narrowitsolution.in/${cleanPath}`;
// };


import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../redux/slices/authSlice";
import axios from "axios";
import "../assets/Login.css";
import { parse } from "tldts";

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, user } = useSelector((state) => state.auth);

  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [company, setCompany] = useState({
    name: "",
    logo: null,
    favicon: null,
    domain: "",
    subdomain: "",
  });

  const [fetchError, setFetchError] = useState("");

  const getDomainInfo = () => {
    const hostname = window.location.hostname;
    const parsed = parse(hostname);
    const domain = parsed.domainWithoutSuffix || "";
    const subdomain = parsed.subdomain || "";
    return { domain, subdomain };
  };

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const { domain } = getDomainInfo();
        const response = await axios.get("https://narrowitsolution.in/api/get-company", {
          params: { domain },
        });
        const data = response.data;

        if (data && Object.keys(data).length > 0) {
          setCompany({
            name: data.name || "",
            logo: data.logo || null,
            favicon: data.favicon || null,
            domain: data.domain || "",
            subdomain: data.subdomain || "",
          });

          if (data.favicon) {
            const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
            link.type = "image/png";
            link.rel = "icon";
            link.href = `${getImageUrl(data.favicon)}`;
            document.head.appendChild(link);
          }
        } else {
          setFetchError("Company info not found.");
        }
      } catch (err) {
        console.error(err);
        setFetchError("");
      }
    };
    fetchCompany();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password !== "y2mfinance@891891") {
      // You can add a specific error state here if needed
      return;
    }
    dispatch(loginUser({ userId, password }));
  };

  useEffect(() => {
    if (user) {
      localStorage.removeItem("superPinVerified");
      navigate("/dashboard");
    }
  }, [user, navigate]);

  return (
    <div className="login-master-container">
      {/* Dynamic Background */}
      <div className="animated-blobs">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="blob blob-3"></div>
      </div>

      <div className="login-glass-card">
        {/* Left Side: Visual/Branding */}
        <div className="login-side-panel">
          <div className="panel-content">
             <div className="brand-logo-wrapper">
                {company.logo ? (
                  <img src={getImageUrl(company.logo)} alt="Logo" className="main-logo" />
                ) : (
                  <div className="fallback-logo">P</div>
                )}
             </div>
             <h1>Welcome to {company.name || "Payyug"}</h1>
             <p>Manage your financial ecosystem with precision and security.</p>
          </div>
          <div className="panel-overlay"></div>
          <img 
            src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
            alt="Dashboard Preview" 
            className="panel-img"
          />
        </div>

        {/* Right Side: Form */}
        <div className="login-form-panel">
          <div className="form-header">
            <h2>Hr Login</h2>
            <p>Enter your credentials to access the portal</p>
          </div>

          {(fetchError || error) && (
            <div className="error-badge">
              <span>⚠️</span> {fetchError || error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="modern-form">
            <div className="input-field">
              <label>User ID</label>
              <div className="input-wrapper">
                <span className="input-icon">👤</span>
                <input
                  type="text"
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                  placeholder="admin_user"
                  required
                />
              </div>
            </div>

            <div className="input-field">
              <label>Password</label>
              <div className="input-wrapper">
                <span className="input-icon">🔒</span>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                />
              </div>
            </div>

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? <span className="spinner"></span> : "Sign In"}
            </button>
          </form>

          <div className="form-footer">
            <p>Terms & Conditions applied</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const getImageUrl = (path) => {
  if (!path) return "";
  const cleanPath = path.startsWith("images/") ? path.slice(7) : path;
  return `https://narrowitsolution.in/${cleanPath}`;
};

export default LoginPage;